/* MoyPickerRenderer.js */

"use strict";
const ComboBoxControl = require("@gluenetworks/combobox").Single;
const BaseSubComponentScheduleRenderer = require("../../base/BaseSubComponentScheduleRenderer");

const MonthOfYearOptions = [
    {label: "January", value: 0},
    {label: "February", value: 1},
    {label: "March", value: 2},
    {label: "April", value: 3},
    {label: "May", value: 4},
    {label: "June", value: 5},
    {label: "July", value: 6},
    {label: "August", value: 7},
    {label: "September", value: 8},
    {label: "October", value: 9},
    {label: "November", value: 10},
    {label: "December", value: 11},
];

class MoyPickerRenderer extends BaseSubComponentScheduleRenderer {
    constructor(model) {
        super(model, "moy-picker-component-g");
    }
    render() {
        if (this._rootElem.hasChildNodes()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._monthComp = new ComboBoxControl({
                    options: MonthOfYearOptions,
                    showFilter: false,
                    adjustWidth: true,
                });
                this._rootElem.appendChild(this._monthComp.renderer.rootElement);
                return this._monthComp.renderer.render();
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return [this._monthComp];
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([super.shutdown(), this._monthComp.shutdown()]);
            })
            .then(() => {
                this._monthComp = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        super._registerListeners();
        this._monthComp.on("UserValue", (this._onMonth = this._onMonth.bind(this)));
    }
    _unregisterListeners() {
        super._unregisterListeners();
        this._monthComp.removeListener("UserValue", this._onMonth);
    }
    _onMonth() {
        this._model.setScheduleProp("moy", this._monthComp.getValue(), true);
    }
    _setControlValuesFromModel() {
        this._monthComp.setValue(this._model.getSchedule().moy);
    }
}
module.exports = MoyPickerRenderer;
